import Cart from './Cart'
import Identification from './Identification'
import Contractor from './Contractor'
import Contract from './Contract'

export default {
  Cart,
  Identification,
  Contractor,
  Contract,
}
